import { useConfig } from "../../../../context/ConfigContext";
import { useDragContext } from "../../context/DragContext";
import type { CompartmentType } from "../../data/Compartment";
import useCompartment, { ModeType } from "../../hooks/useCompartment";

interface OverlayMaterialProps {
	compartment: CompartmentType;
}

export default function OverlayMaterial({ compartment }: OverlayMaterialProps) {
	const { mode } = useConfig();
	const dragContext = useDragContext();
	const { canApplyCurrentMode, currentModeColor, isHovered, isSelected } =
		useCompartment(compartment);

	return (
		<meshStandardMaterial
			visible={
				(canApplyCurrentMode === true || isHovered || isSelected) &&
				!dragContext?.isDragging &&
				mode !== "view"
			}
			transparent
			opacity={currentModeColor !== ModeType.hover && isHovered ? 0.6 : 0.4}
			color={currentModeColor}
		/>
	);
}
